'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function (endpoint, id) {
  var handlers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var perform = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(name, params) {
      var url, data, response, _ref2, result;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = endpoint + '?' + _qs2.default.stringify(params);
              data = new FormData();

              data.append('query', name);

              _context.next = 5;
              return fetch(url, {
                method: 'POST',
                body: data,
                headers: {
                  'X-OCTOBER-REQUEST-HANDLER': id + '::onQuery',
                  'X-Requested-With': 'XMLHttpRequest'
                }
              });

            case 5:
              response = _context.sent;
              _context.next = 8;
              return response.json();

            case 8:
              _ref2 = _context.sent;
              result = _ref2.result;
              return _context.abrupt('return', result);

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));

    return function perform(_x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();

  return function (store) {
    return function (next) {
      return function (action) {
        var dispatch = store.dispatch,
            getState = store.getState;
        var type = action.type,
            payload = action.payload;


        var performInit = function () {
          var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            var queries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    dispatch({ type: _actions.BATCH_START });

                    _context2.next = 3;
                    return Promise.all([].concat(_toConsumableArray(queries.map(function (_ref4) {
                      var name = _ref4.name,
                          params = _ref4.params;

                      return performQuery(name, params);
                    }))));

                  case 3:

                    dispatch({ type: _actions.BATCH_FINISH });

                  case 4:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, undefined);
          }));

          return function performInit() {
            return _ref3.apply(this, arguments);
          };
        }();

        var performQuery = function () {
          var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(name) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var _res, _getState$queries$nam, query, handler;

            return regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    // TODO: Check if cached version exists

                    dispatch({
                      type: _actions.PERFORM_REQUEST,
                      meta: { name: name, params: params }
                    });

                    _context3.prev = 1;
                    _context3.next = 4;
                    return perform(name, params);

                  case 4:
                    _res = _context3.sent;
                    _getState$queries$nam = getState().queries[name], query = _getState$queries$nam === undefined ? {} : _getState$queries$nam;
                    handler = getHandler(query);


                    dispatch({
                      type: _actions.PERFORM_SUCCESS,
                      payload: handler(_res, query),
                      meta: { name: name, params: params }
                    });

                    _context3.next = 13;
                    break;

                  case 10:
                    _context3.prev = 10;
                    _context3.t0 = _context3['catch'](1);

                    dispatch({
                      type: _actions.PERFORM_FAILURE,
                      payload: _context3.t0,
                      meta: { name: name, params: params },
                      error: true
                    });

                  case 13:
                  case 'end':
                    return _context3.stop();
                }
              }
            }, _callee3, undefined, [[1, 10]]);
          }));

          return function performQuery(_x5) {
            return _ref5.apply(this, arguments);
          };
        }();

        var getHandler = function getHandler(_ref6) {
          var _ref6$handler = _ref6.handler,
              handleName = _ref6$handler === undefined ? null : _ref6$handler;

          return handlers[handleName] ? handlers[handleName] : function (res) {
            return { results: res };
          };
        };

        var res = next(action);

        if (type === _actions.INIT) {
          performInit(payload);
        }

        if (type === _actions.UPDATE) {
          performQuery(payload.name, payload.params);
        }

        return res;
      };
    };
  };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@jump/pages/lib/api.js
// module id = 256
// module chunks = 0